export default "__VITE_ASSET__OnBc$D2Q__"